import { Search } from '@/ui/svg';
import SearchDialog from '../search-dialog';
import { useSearchDialog, SearchProvider } from '@bitbot/model';
import { useRouter } from 'next/router';
import HapticContainer from '../common/haptic-container';
import { sendGAEvent } from '@next/third-parties/google';

export default function TradeSearch() {
  const { showSearch, setShowSearch } = useSearchDialog();
  const router = useRouter();
  return (
    <div className="flex justify-between gap-[0.625rem] pt-2 fixed bottom-0 z-[100] left-0 right-0 px-4 bg-primary font-nunito_sans bottom-safe-area">
      <HapticContainer
        onClick={() => {
          setShowSearch(true);
          sendGAEvent('event', 'click_home_search');
        }}
        className="flex bg-secondary px-[10px] py-2 rounded-[16px] items-center gap-[0.625rem] text-secondary flex-grow cursor-pointer"
      >
        <Search className="w-6 h-6" />
        <div className="text-tertiary text-lg font-semibold">Search</div>
      </HapticContainer>
      {/* <HapticContainer className="flex items-center justify-center w-[94px] h-[52px]">
        <div
          onClick={() => {
            router.push(
              '/trade?pairAddress=0xf87e9c413f5d50471aa46d13Fa69e5a09039205e',
            );
          }}
          className="bg-btn-primary text-white flex w-[94px] h-[52px] transition-all duration-200 active:w-[90px] active:h-[50px] items-center justify-center text-lg font-bold rounded-2xl cursor-pointer"
        >
          Trade
        </div>
      </HapticContainer> */}
      <SearchProvider
        onChangePair={pairAddress => {
          setShowSearch(false);
          router.push(`/trade?pairAddress=${pairAddress}`);
        }}
      >
        <SearchDialog
          open={showSearch}
          toggle={setShowSearch}
          hideCloseIcon
          hideUnderline
        />
      </SearchProvider>
    </div>
  );
}
